import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/lib/lenis";

export default function Navbar() {
  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0E17]/60 border-b border-white/10"
    >
      <div className="flex items-center justify-between px-6 md:px-12 py-5">
        <a href="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="ROSTENO logo"
            className="w-7 h-7 rounded-lg"
          />
          <span className="font-mono-accent text-sm tracking-[0.35em] uppercase">
            Rosteno
          </span>
        </a>
        <button
          data-testid="nav-join-waitlist-btn"
          onClick={() => scrollToSection("#waitlist")}
          className="group flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.2em] rounded-full bg-gradient-to-r from-[#34D399] to-[#38BDF8] text-black px-5 py-2.5 transition-opacity duration-300 hover:opacity-85"
        >
          Join Waitlist
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </div>
    </motion.header>
  );
}
